import React, { Component } from 'react';
import { withRouter } from 'react-router';


class AccountTimesheetTable extends Component {
    static displayName = AccountTimesheetTable.name;

    constructor(props) {
        super(props);

        this.handleEditTimesheet = this.handleEditTimesheet.bind(this)
        this.handleCertifyTimesheet = this.handleCertifyTimesheet.bind(this)
    }

    async handleCertifyTimesheet(event) {
        if (window.confirm("Are you sure you'd like to certify this timesheet?")) {
            const timesheet = this.props.store.timesheets.getById(event.target.value);
            
            timesheet.isCertified = true;

            await timesheet.save(this.props.store);

            await this.props.store.getFromApi()
        }
    }

    handleEditTimesheet(event) {
        this.props.history.push("/staff/Timesheet/" + event.target.value);
    }

    displayCertifiedBadge(timesheet) {
        if (timesheet.isCertified) {
            return (
                <span className="badge badge-secondary"
                    style= {{
                        textAlign: "center"
                    }}>{timesheet.dateCertifiedObject.format("MM/DD/YY h:mm:ss a")}</span>
            )
        }
        else {
            return (
                <span className="badge badge-secondary"
                    style= {{
                        textAlign: "center",
                        backgroundColor: "#F2100C"
                    }}>Uncertified</span>            
            )
        }
    }



    render() {
        return (
            <table className="w-100 table-hover">
                <thead>
                    <tr>
                        {this.props.showCertified &&
                            (<th style={{borderBottom:0, width: "5%"}} scope="col"></th>)
                        }
                        {this.props.showStudentName &&
                            <th scope="col">Student Name</th>
                        }
                        {this.props.showFopal &&
                            <th scope="col">FOPAL</th>
                        }
                        <th scope="col">Hours</th>
                        {this.props.showSubmittedDate && (<th scope="col">Sumbitted</th>)}
                        {this.props.showCertifiedDate && (<th scope="col">Certified</th>)}
                        {this.props.showWeekEndDate && (<th scope="col">Week End Date</th>)}
                        <th scope="col">Sat</th>
                        <th scope="col">Sun</th>
                        <th scope="col">Mon</th>
                        <th scope="col">Tue</th>
                        <th scope="col">Wed</th>
                        <th scope="col">Thu</th>
                        <th scope="col">Fri</th>
                        <th scope="col">Week Pay</th>
                        <th scope="col">Balance At Date</th>
                    </tr>
                </thead>
                <tbody>
                    {this.props.accounts.map((account, i) =>
                        <React.Fragment>
                            {account.timesheets.map((timesheet) =>
                                <tr key={"timesheet-" + timesheet.id} >
                                    {this.props.showCertified && (
                                        <td style={{ width: "5%"}}>
                                            {timesheet.isCertified ?
                                                (<button className="btn btn-light btn-sm" 
                                                    value={timesheet.id} onClick={this.handleEditTimesheet}>
                                                        View
                                                </button>) :
                                                (<button className="btn btn-light btn-sm" 
                                                    value={timesheet.id} onClick={this.handleEditTimesheet}>
                                                        Edit
                                                </button>)
                                            }
                                        </td>
                                    )}
                                    {this.props.showStudentName &&
                                        <td>{account.student.name}</td>
                                    }
                                    {this.props.showFopal &&
                                        <td>{account.fopal}</td>
                                    }
                                    <td>{timesheet.totalHours.toFixed(2)}</td>

                                    {this.props.showSubmittedDate &&
                                        (<td>
                                            {timesheet.isFinal ? 
                                                (<span className="badge badge-secondary text-center">
                                                    {timesheet.dateSubmittedObject.format("MM/DD/YY h:mm:ss a")}
                                                </span>) : 
                                                "N/A"
                                            }
                                        </td>)}
                                    
                                    {this.props.showCertifiedDate &&
                                        (<td>{this.displayCertifiedBadge(timesheet)}</td>)
                                    }

                                    {this.props.showWeekEndDate && 
                                        (<td>{timesheet.weekEndDateObject.format("l")}</td>)
                                    }                                   
                                    <td>{this.props.store.timestamps.getById(timesheet.timestampIds[0]).totalTime}</td>
                                    <td>{this.props.store.timestamps.getById(timesheet.timestampIds[1]).totalTime}</td>
                                    <td>{this.props.store.timestamps.getById(timesheet.timestampIds[2]).totalTime}</td>
                                    <td>{this.props.store.timestamps.getById(timesheet.timestampIds[3]).totalTime}</td>
                                    <td>{this.props.store.timestamps.getById(timesheet.timestampIds[4]).totalTime}</td>
                                    <td>{this.props.store.timestamps.getById(timesheet.timestampIds[5]).totalTime}</td>
                                    <td>{this.props.store.timestamps.getById(timesheet.timestampIds[6]).totalTime}</td>
                                    <td>${timesheet.totalPay.toFixed(2)}</td>
                                    <td>${timesheet.balanceAtDate.toFixed(2)}</td>
                                </tr>
                            )}
                        </React.Fragment>
                    )}
                </tbody>
            </table>

        )
    }
}

//withRouter "connects" the component to the router, letting us redirect the page.
export default withRouter(AccountTimesheetTable);